import { UserRole } from "../../Profile/enums/profileEnums";
import { canAccessDashboardAnalytics } from "./sidebarRoleAccess";

type RoleInput = UserRole | undefined;

/** HLD §9 — school owner / bursar. Full module access. */
export function isEducationAdmin(role: RoleInput): boolean {
  return role === UserRole.COMPANY_ADMIN;
}

/** HLD §9 — cashier; fee collection and shared finance lists. */
export function isEducationCashier(role: RoleInput): boolean {
  return role === UserRole.SALES_PROCUREMENT;
}

/** HLD §9 — inventory manager; stock and procurement. */
export function isEducationInventoryManager(role: RoleInput): boolean {
  return role === UserRole.WAREHOUSE_MANAGER;
}

/** HLD §9 — auditor; reports and read-only overview. */
export function isEducationAuditor(role: RoleInput): boolean {
  return role === UserRole.ANALYST;
}

export function canAccessEducationDashboard(role: RoleInput): boolean {
  if (role == null) return false;
  return canAccessDashboardAnalytics(role) || isEducationAuditor(role);
}

export function canAccessEducationAcademicNav(role: RoleInput): boolean {
  if (role == null) return false;
  return isEducationAdmin(role);
}

export function canAccessEducationFinanceNav(role: RoleInput): boolean {
  if (role == null) return false;
  return (
    isEducationAdmin(role) ||
    isEducationCashier(role) ||
    isEducationAuditor(role)
  );
}

export function canAccessEducationFinanceOperationsNav(
  role: RoleInput
): boolean {
  if (role == null) return false;
  return isEducationAdmin(role) || isEducationCashier(role);
}

export function canAccessEducationProcurementNav(role: RoleInput): boolean {
  if (role == null) return false;
  return isEducationAdmin(role) || isEducationInventoryManager(role);
}

export function canAccessEducationInventoryNav(role: RoleInput): boolean {
  if (role == null) return false;
  return isEducationAdmin(role) || isEducationInventoryManager(role);
}

export function canAccessEducationAuditNav(role: RoleInput): boolean {
  if (role == null) return false;
  return (
    isEducationAdmin(role) ||
    isEducationAuditor(role) ||
    isEducationInventoryManager(role)
  );
}

export function canAccessEducationSettingsNav(role: RoleInput): boolean {
  return isEducationAdmin(role);
}
